import React from 'react';

import AlertIcon from 'widget/shared/icons/AlertIcon';
import { IconColor, IconSize } from 'widget/shared/icons/BaseIcon';
import { WidgetTexts } from 'widget/consts/texts';

import styles from './MessageError.module.scss';

export type MessageErrorProps = {
  messageId: string;
  onRetry: (messageId: string) => void;
};

const MessageError: React.FC<MessageErrorProps> = ({ messageId, onRetry }) => {
  const handleRetry = React.useCallback(() => {
    onRetry(messageId);
  }, [onRetry, messageId]);

  return (
    <div className={styles['error']}>
      <div className={styles['error__text']}>
        <AlertIcon size={IconSize.SM} color={IconColor.Error} />
        <span>{WidgetTexts.messageList.error.text}</span>
      </div>
      <button
        className={styles['error__retry']}
        onClick={handleRetry}
        type="button"
      >
        {WidgetTexts.messageList.error.retry}
      </button>
    </div>
  );
};

export default MessageError;
